export const userSteamSettings = [
  {
    icon: 'privateDetails',
    key: 'details',
  },
  {
    icon: 'privateFriends',
    key: 'friends',
  },
  {
    icon: 'privateGame',
    key: 'game',
  },
  {
    icon: 'privateInventory',
    key: 'inventory',
  },
]
